var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUseRossum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M34.768 16.254c1.823 4.931.871 10.684-2.949 14.802-5.41 5.832-14.523 6.174-20.355.764S5.29 17.297 10.7 11.465c4.395-4.738 11.234-5.853 16.773-3.203"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 31.956,
    cy: 11.606,
    r: 1.445
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseRossum);
export default __webpack_public_path__ + "static/media/use_rossum.6a49e812e06f55a8f434b5130d90b91a.svg";
export { ForwardRef as ReactComponent };